import { render, staticRenderFns } from "./panoramic-hotel.vue?vue&type=template&id=4c26173e&scoped=true"
import script from "./panoramic-hotel.vue?vue&type=script&lang=js"
export * from "./panoramic-hotel.vue?vue&type=script&lang=js"
import style0 from "./panoramic-hotel.vue?vue&type=style&index=0&id=4c26173e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c26173e",
  null
  
)

export default component.exports